import React, { useState, useEffect } from "react";

import ComponentModal, { ModalSize } from "./ComponentModal";
import PropTypes from "prop-types";

import LogService from "../../../middleware/CommonSdk/LogService";

export { ModalSize };

const LOG_TAG = "CLOSE_ON_SUCCESS_MODAL_WIZARD";
const ModalId = "CloseOnSuccessModalWizardId"

const CloseOnSuccessModalWizard = (props) => {
    const [modal, setModal] = useState(null);

    useEffect(() => {
        LogService.trace(LOG_TAG, "useEffect getComponent");
        if (props.getComponent) {
            setModal(
                <ComponentModal
                    id={ModalId}
                    title={props.title}
                    icon={props.icon}
                    showFirstButton={false}
                    showModalOnInit={true}
                    size={props.modalSize}
                    iconColor={props.iconColor}
                >
                    {props.getComponent(handleOnSuccess, handleOnFailed)}
                </ComponentModal>
            );
        }
    }, [props.getComponent]);

    const handleOnSuccess = () => {
        LogService.debug(LOG_TAG, "handleOnSuccess");
        setModal(
            <ComponentModal
                id={ModalId}
                closeModal={true}
            />
        );
    }

    const handleOnFailed = (title) => {
        LogService.debug(LOG_TAG, "handleOnFailed");
        setModal(
            <ComponentModal
                id={ModalId}
                title={title}
                icon={props.icon}
                showFirstButton={false}
                showModalOnInit={true}
                size={props.modalSize}
                iconColor="warning"
                titleColor="warning"
            >
                {props.getComponent(handleOnSuccess, handleOnFailed)}
            </ComponentModal>
        );
    }

    LogService.trace(LOG_TAG, "render");

    return (
        <div>
            {modal}
        </div>
    );
}

CloseOnSuccessModalWizard.defaultProps = {
    title: "",
    icon: null,
    iconColor: null,
    getComponent: null,
    modalSize: ModalSize.Big
}

CloseOnSuccessModalWizard.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.object,
    iconColor: PropTypes.string,
    getComponent: PropTypes.func,
    modalSize: PropTypes.oneOf(Object.keys(ModalSize))
};

export default CloseOnSuccessModalWizard;